import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { NuvemEnvioLabelConcatenationStatusResponseDto } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioLabelConcatenationStatusData,
  getNuvemEnvioLabelConcatenationStatusStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  getLabelConcatenationStatus as getLabelConcatenationStatusAction,
  resetLabelConcatenationStatus as resetLabelConcatenationStatusAction,
} from '../../ordersSlice/ordersSlice';

export interface UseGetConcatenateLabelsResult {
  getConcatenateLabels: (
    id: string,
  ) => Promise<NuvemEnvioLabelConcatenationStatusResponseDto>;
  resetConcatenateLabels: () => void;
  data: NuvemEnvioLabelConcatenationStatusResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
}

function useGetConcatenateLabels(_id: string): UseGetConcatenateLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioLabelConcatenationStatusData);
  const status = useSelector(getNuvemEnvioLabelConcatenationStatusStatus);

  const getConcatenateLabels = useCallback(
    async (
      concatenationId: string,
    ): Promise<NuvemEnvioLabelConcatenationStatusResponseDto> => {
      const response = await dispatch(
        getLabelConcatenationStatusAction(concatenationId),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetConcatenateLabels = useCallback(() => {
    dispatch(resetLabelConcatenationStatusAction());
  }, [dispatch]);

  return {
    getConcatenateLabels,
    resetConcatenateLabels,
    data,
    status,
  };
}

export default useGetConcatenateLabels;
